import { Button, ButtonProps } from '@chakra-ui/react';
import styled from 'styled-components';

export const ButtonIconPassword = styled(Button).attrs({
  p: 0.5,
  size: 'sm',
  variant: 'ghost'
} as ButtonProps)``;
